module.exports = __webpack_public_path__ + "static/rootstock_partner-e550747e44beff1dc33603532afaa3bd.svg";